<template>
    <app-box :loading="loading">
        <div class="flex -mx-4">
            <div class="w-1/4 px-4">
                <draggable :list="options" :clone="clone" :options="{draggable:'.item-bar', handle:'.item-bar', group:{ name:'items',  pull:'clone', put:'false' }}">
                    <div v-for="option in options" class="px-4 py-2 bg-grey-lighter text-sm w-full mb-8 cursor-pointer item-bar">
                        <span v-html="option.title"></span>
                    </div>
                </draggable>

                <div v-if="pages.length > 0">
                    <h4 class="mb-4 pb-2 border-b border-grey-light">Pages</h4>
                    <draggable :list="pages" :clone="clonePage" :options="{draggable:'.page-bar', handle:'.page-bar', group:{ name:'items',  pull:'clone', put:'false' }}">
                        <div v-for="page in pages" class="page-bar px-4 py-2 bg-grey-lighter text-xs w-full mb-2 cursor-pointer">
                            <span v-html="page.title"></span>
                        </div>
                    </draggable>
                </div>
            </div>
            <div class="w-3/4 px-4 relative z-20">
                <div v-if="items.length == 0" class="absolute flex items-center justify-center p-8 border-2 border-grey-lighter border-dashed" style="min-height: 20rem; z-index: -1; left: 1rem; right: 1rem; top: 0;">
                    <span class="text-xl text-grey">Drag an item here...</span>
                </div>
                <draggable :list="items" :element="'ol'" :options="{draggable:'.item', handle:'.itemHandle', group:'items'}" class="mb-8 list-reset" style="min-height: 20rem">
                    <li v-for="(item, index) in items" class="item itemHandle mb-8">
                        <app-menu-bar
                            :item="item"
                            :locales="locales"
                            @delete="deleteItem(index)"
                        />
                        <draggable :list="item.children" :element="'ol'" :options="{draggable:'.childItem', handle:'.childItemHandle', group:'items'}" style="min-height: 4rem;" class="isChildren list-reset relative border-2 border-grey-lighter border-dashed p-6 pt-8">

                            <li v-for="(child, childIndex) in item.children" class="childItem childItemHandle mb-4">
                                <app-menu-bar
                                    :item="child"
                                    :locales="locales"
                                    @delete="deleteChild(index, childIndex)"
                                />
                            </li>
                        </draggable>
                    </li>
                </draggable>
            </div>
        </div>
    </app-box>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';

    import draggable from 'vuedraggable';
    import Vue from 'vue';
    import { mapGetters } from 'vuex';

    /* Components */
    import Box from '@/components/Box.vue';
    import MenuBar from '@/components/menu/Bar.vue';

    export default {
        components: {
            draggable,
            'app-box': Box,
            'app-menu-bar': MenuBar
        },
        
        props: {
            menu: {
                type: Array,
                required: false
            }
        },

        data: () => ({
            loading: true,
            items: [],
            options: [
                {
                    title: 'New item',
                    type: 'Custom Link',
                    label: 'Custom Link'
                },
                {
                    title: 'New CTA',
                    type: 'CTA',
                    label: 'CTA'
                }
            ],
            pages: []
        }),

        mounted() {
            console.log(this.menu);
            if (typeof this.menu !== 'undefined' && this.menu.length > 0) {
                for (let i in this.menu) {
                    let item = this.menu[i];

                    item.open = false;
                    this.items.push(item);
                }
            }

            this.getPages()
                .then(response => {
                    this.loading = false;
                })
        },

        methods: {
            getPages() {
                return Api.request('get', `menus/pages`)
                    .then(({ data }) => {
                        this.pages = data.pages;
                    });
            },
            clone(me) {
                let option = JSON.parse(JSON.stringify(me));

                let locales = {};
                if (this.locales.length > 0) {
                    this.locales.forEach((l, i) => {
                        locales[l.id] = {
                            label: 'Custom Link',
                            url: '/',
                            newTab: false
                        }
                    });
                }

                return {
                    type: option.type,
                    label: option.label,
                    locales: locales,
                    open: false,
                    children: []
                };
            },
            clonePage(me) {
                let page = JSON.parse(JSON.stringify(me));

                return {
                    type: 'Page',
                    label: page.title,
                    page: page.id,
                    newTab: false,
                    open: false,
                    children: []
                };
            },
            deleteItem(index) {
                Vue.delete(this.items, index);
            },
            deleteChild(index, childIndex) {
                Vue.delete(this.items[index].children, childIndex);
            },
            save() {
                this.$emit('save', this.items);
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },

        watch: {
            'items': {
                deep: true,
                handler() {
                    this.save();
                }
            }
        }
    }
</script>

<style>
    .isChildren {
        @apply .relative;
    }
    .isChildren:before {
        @apply .block .absolute .font-bold .uppercase;

        font-size: 0.63333rem;
        top: 0.5rem;
        left: 0.5rem;

        content: 'Children';
    }
</style>



// WEBPACK FOOTER //
// src/components/MenuManager.vue